// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rank[data-v-de60ddf6]{padding-left:20px;font-weight:600;color:#2c6dff;font-size:20pt}.emission-column[data-v-de60ddf6]{background-color:#b0f1db}.participant-image[data-v-de60ddf6]{height:50x;width:50px;margin-right:10px;border-radius:50%;background-color:#e8e8e8}.participant-image img[data-v-de60ddf6]{border-radius:50%;height:100%;width:100%}.col-width[data-v-de60ddf6]{width:20%;padding:10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
